module.exports = __webpack_public_path__ + "static/media/Malaysia_logo_white_2021.c31644ac.png";